import React, {
    createContext,
    useMemo,
    useState,
} from 'react';
import PropTypes from 'prop-types';

export const AppContext = createContext({
    isOwnershipRequest: false,
    setOwnershipRequest: () => null,
    pageTitle: null,
    setPageTitle: () => null,
});

export const AppProvider = ({ children }) => {
    const [
        isOwnershipRequest,
        setOwnershipRequest,
    ] = useState(false);
    const [
        pageTitle,
        setPageTitle,
    ] = useState('Online Directory');
    const [
        pageDescription,
        setPageDescription,
    ] = useState('An online directory where communities come together to connect, share, and thrive.');

    const contextValue = useMemo(() => ({
        isOwnershipRequest,
        setOwnershipRequest,
        pageTitle,
        setPageTitle,
        pageDescription,
        setPageDescription,
    }), [
        isOwnershipRequest,
        pageTitle,
        pageDescription,
    ]);

    return (
        <AppContext.Provider value={contextValue}>
            {children}
        </AppContext.Provider>
    );
};

AppProvider.propTypes = {
    children: PropTypes.element.isRequired,
};
